export default __webpack_public_path__ + "static/media/fontRoboto900_latin_ext.cbba5b97.woff2";